/* tslint:disable */
/* eslint-disable */
/**
 * Midcoast Water Bureau API
 * Backend API documentation for Midcoast Water Bureau application. This API provides endpoints for user management, device monitoring, water meter measurements, and notification systems.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: support@nucleus3.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DeviceLinkClaimRequest } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { DeviceLinkClaimResponse } from '../n3-backend-open-api-gen/model';
// @ts-ignore
import type { DeviceLinkSuggestionResponse } from '../n3-backend-open-api-gen/model';
/**
 * DeviceLinkClaimsApi - axios parameter creator
 */
export const DeviceLinkClaimsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Claim recommended devices and create customer links
         * @param {DeviceLinkClaimRequest} deviceLinkClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimDevices: async (deviceLinkClaimRequest: DeviceLinkClaimRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceLinkClaimRequest' is not null or undefined
            assertParamExists('claimDevices', 'deviceLinkClaimRequest', deviceLinkClaimRequest)
            const localVarPath = `/api/v1/device-link-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceLinkClaimRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get recommended devices for the current customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/device-link-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceLinkClaimsApi - functional programming interface
 */
export const DeviceLinkClaimsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceLinkClaimsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Claim recommended devices and create customer links
         * @param {DeviceLinkClaimRequest} deviceLinkClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimDevices(deviceLinkClaimRequest: DeviceLinkClaimRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceLinkClaimResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimDevices(deviceLinkClaimRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceLinkClaimsApi.claimDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get recommended devices for the current customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuggestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceLinkSuggestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuggestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceLinkClaimsApi.getSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceLinkClaimsApi - factory interface
 */
export const DeviceLinkClaimsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceLinkClaimsApiFp(configuration)
    return {
        /**
         * 
         * @summary Claim recommended devices and create customer links
         * @param {DeviceLinkClaimRequest} deviceLinkClaimRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimDevices(deviceLinkClaimRequest: DeviceLinkClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeviceLinkClaimResponse> {
            return localVarFp.claimDevices(deviceLinkClaimRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get recommended devices for the current customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuggestions(options?: RawAxiosRequestConfig): AxiosPromise<DeviceLinkSuggestionResponse> {
            return localVarFp.getSuggestions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceLinkClaimsApi - object-oriented interface
 */
export class DeviceLinkClaimsApi extends BaseAPI {
    /**
     * 
     * @summary Claim recommended devices and create customer links
     * @param {DeviceLinkClaimRequest} deviceLinkClaimRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public claimDevices(deviceLinkClaimRequest: DeviceLinkClaimRequest, options?: RawAxiosRequestConfig) {
        return DeviceLinkClaimsApiFp(this.configuration).claimDevices(deviceLinkClaimRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get recommended devices for the current customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getSuggestions(options?: RawAxiosRequestConfig) {
        return DeviceLinkClaimsApiFp(this.configuration).getSuggestions(options).then((request) => request(this.axios, this.basePath));
    }
}

